import * as actionTypes from "../../../../actions/actionTypes";
import {updateObject} from "../../../../../utils/utils";

const initialState = {

    loading : true,
    error : null,
    listeRessources: []

};

const etudiantMesCoursFetchCoursRessourcesStart = (state,action) => {
    return updateObject(state,{
        loading:true,
        error:null,
        listeRessources: null
    });
};

const etudiantMesCoursFetchCoursRessourcesSuccess = (state,action) => {
    return updateObject(state,{
        loading:false,
        error:null,
        listeRessources: action.payload.listeRessources
    });
};

const etudiantMesCoursFetchCoursRessourcesFail = (state,action) => {
    return updateObject(state,{
        loading:false,
        error:action.payload.error,
        listeRessources: []
    });
};

const etudiantMesCoursFetchCoursRessourcesReset = (state,action) => {
    return updateObject(state,initialState);
};



const reducer = (state = initialState,action) => {
    switch (action.type) {

        case actionTypes.ETUDIANT_MES_COURS_FETCH_COURS_RESSOURCES_START : return etudiantMesCoursFetchCoursRessourcesStart(state,action);
        case actionTypes.ETUDIANT_MES_COURS_FETCH_COURS_RESSOURCES_SUCCESS : return etudiantMesCoursFetchCoursRessourcesSuccess(state,action);
        case actionTypes.ETUDIANT_MES_COURS_FETCH_COURS_RESSOURCES_FAIL : return etudiantMesCoursFetchCoursRessourcesFail(state,action);
        case actionTypes.ETUDIANT_MES_COURS_FETCH_COURS_RESSOURCES_RESET : return etudiantMesCoursFetchCoursRessourcesReset(state,action);
        default : return state;
    }
};

export default reducer;